import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Company Code Services
 * !== 업체 코드 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/cocd`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co-cd`,
    api_co: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co`,
    infAPi: `${process.env.REACT_APP_API_LCMI}/api/v1/lcmi/comn`,
    nodes: [],
};

export const URLS = {
    ptli0407001q: `${BASE.path}/ptli0407001q`, // Company Code List !==  업체 코드 목록 ==!
    ptli0407002s: `${BASE.path}/ptli0407002s`, // Company Code Registration !==  업체 코드 등록 ==!
    ptli0407003s: `${BASE.path}/ptli0407003s`, // Company Code Modification !==  업체 코드 수정 ==!
};

export const APIS = {
    // Check Company Approval List !==  업체 코드 목록 조회 ==!
    getCoCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Company Approval details inquiry !== 업체 코드 상세 정보 조회 ==!
    getCoCdInfo: (coTin: any, coSn: any) => {
        return api.get(`${BASE.api}/${coTin}/${coSn}`);
    },
    // Create Company Code !== 업체 코드 생성 ==!
    createCoCd: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Company Code !==  업체 코드 수정 ==!
    updateCoCd: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete Company Code !== 업체 코드 삭제 ==!
    deleteCoCd: (coTin: any, coSn: any) => {
        return api.delete(`${BASE.api}/${coTin}/${coSn}`);
    },

    getLcmWrhsCoTpMap: (coTin: any) => api.get(`${BASE.api_co}/lcm-wrhs-cotp-map?coTin=${coTin}`),

    // EPZ License Permission Information Search !== EPZ 면허 허가 정보  ==!
    getEpzLcnePrmssInfo: (coTin: any) => api.get(`${BASE.api_co}/epz-lcne-prmss?coTin=${coTin}`),

    // Check Company Approval List !==  업체 코드 엑셀 목록 조회 ==!
    getCoCdExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),

    // Check TASAC CFA Certificate Information (IF-E-LCM-003) !== ICD, CFS 증명서 정보 확인 ==!
    chkWrhsCertificate: (data: any) => {
        return api.get(`${BASE.infAPi}/chkCertificate/wrhs`, {
            params: {
                ...comnUtils.toGetParams(data),
            },
        });
    },
};

export const SF_CO_CD_SRCH: TFormSchema = {
    id: "form_coAprvSrch",
    schema: {
        coTin: { type: "text", label: "L_CO_TIN" },
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            area: "comnCd",
            comnCd: "COM0011",
            all: true,
            editType: "both",
        },
        coNm: { type: "text", label: "L_CO_NM" },
    },
};

export const SF_CO_CD_INFO: TFormSchema = {
    id: "form_coCdInfo",
    schema: {
        coTin: {
            type: "code",
            label: "L_CO_TIN",
            area: "coCd",
            popupSize: "md",
            required: true,
        },
        coSn: { label: "L_CO_SN", type: "text" },
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            all: false,
            area: "comnCd",
            comnCd: "COM0011",
            required: true,
            editType: "both",
        },
        coCdRo: { label: "L_CO_CD", type: "text", placeholder: "automatically generated", readOnly: true },
        coCdSelect: { label: "L_CO_CD", type: "select", required: true },
        coCd: { label: "L_CO_CD", type: "text", placeholder: "Direct input", required: true },
        coTpNm: { label: "L_CO_CD_NM", type: "text", required: true },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                dclrYn: "Y",
            },
            required: true,
        },
        tasacCrtfNo: {
            label: "L_TASC_CRTF_NO",
            type: "text",
            placeholder: "Direct input",
        },
        prcssStatCd: { label: "L_PRCSS_STAT_CD", type: "text" }, //본 테이블에만 존재
        statMdfyRsn: { label: "L_STAT_MDFY_RSN", type: "text" }, //본 테이블에만 존재
        gainCfrmOmsnYn: {
            type: "select",
            label: "L_GAIN_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        gaotCfrmOmsnYn: {
            type: "select",
            label: "L_GAOT_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        stckCretCtraTpCd: {
            type: "select",
            label: "L_STCK_CRET_CTRA_TP_CD",

            area: "comnCd",
            comnCd: "CGM0095",
        },
        stckClarCtraTpCd: {
            type: "select",
            label: "L_STCK_CLAR_CTRA_TP_CD",
            area: "comnCd",
            comnCd: "CGM0096",
        },
        autoCriYn: {
            type: "select",
            label: "L_AUTO_CRI_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        autoCroYn: {
            type: "select",
            label: "L_AUTO_CRO_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        wrhsDpstDays: { label: "L_WRHS_DPST_DAYS", type: "number" },
        psnWrhsYn: {
            type: "select",
            label: "L_PSN_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        spcdlWrhsYn: {
            type: "select",
            label: "L_SPCDL_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        rskCagYn: {
            type: "select",
            label: "L_RSK_CAG_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        bsopId: {
            type: "file",
            label: "L_ATCH_FILE",
            edit: true,
            bsopClsfCd: "PTL",
            isPublic: true,
        },
        lcneUseTpCd: {
            type: "select",
            label: "L_LCNE_TP_CD",
            area: "comnCd",
            comnCd: "LCM0019",
            required: true,
        },
    },
};

export const SG_CO_CD_LIST: TGridSchema = {
    id: "grid_coCdList",
    options: { pagination: "out", index: true, height: "auto" },
    head: [
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: "10%" }] },
        { cells: [{ header: "L_CO_TP_CD", binding: "coTpCd", width: "10%" }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coTpNm", width: "*" }] },
        { cells: [{ header: "L_RPPN_NM", binding: "rppnNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "coCd" }],
        },
        {
            cells: [{ binding: "coTpCd" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coTpNm", align: "left" }],
        },
        {
            cells: [{ binding: "rppnNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmOfceCd", type: "code", area: "cstmCd", align: "left" }],
        },
    ],
};

export const CO_CD_INPUT_TRGT_SET = new Set(["AL", "BK", "FF", "SA", "SL", "VD"]);

interface InputProperties {
    maxLength: number;
    placeholder: string;
}

export const CO_CD_INPUT_PROPERTIES: { [key: string]: InputProperties } = {
    AL: { maxLength: 2, placeholder: "Enter the 2-char code" },
    FF: { maxLength: 4, placeholder: "Enter the 4-char code" },
    GD: { maxLength: 9, placeholder: "Enter the code" },
    SA: { maxLength: 3, placeholder: "Enter the 3-char code" },
    SL: { maxLength: 3, placeholder: "Enter the 3-char code" },
    BK: { maxLength: 8, placeholder: "Enter the 8-char(4char + 2char + 2char) code" },
    RW: { maxLength: 3, placeholder: "Enter the 3-char code" },
    VD: { maxLength: 9, placeholder: "Enter the code" },
};

// 첨부파일
export const ATCH_FILE_VISIBILITY_MAP = new Map([
    ["AL", new Set(["bsopId"])],
    ["WA", new Set(["bsopId"])],
    ["FF", new Set(["bsopId"])], // Freight Fowarder
    ["SA", new Set(["bsopId"])], // Shipping Agent
    ["SL", new Set(["bsopId"])], // Shipping line
    ["TA", new Set(["bsopId"])], // Terminal Operators
    ["TO", new Set(["bsopId"])], // Terminal Operators (Sea)
]);

export const SG_CO_CD_EXCEL_LIST: TGridSchema = {
    id: "grid_coCdExcelList",
    options: { pagination: "out", index: true, height: "auto" },
    head: [
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: "10%" }] },
        { cells: [{ header: "L_CO_TP_CD", binding: "coTpCd", width: "10%" }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPPN_NM", binding: "rppnNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "coCd" }],
        },
        {
            cells: [{ binding: "coTpCd" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "rppnNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmOfceCd", type: "code", area: "cstmCd", align: "left" }],
        },
    ],
};
